export const toast = $state({
  visible: false,
  message: '',
  kind: 'success'
});

let _timer = null;

export function showToast(message, kind = 'success', durationMs = 3000) {
  toast.message = message;
  toast.kind = kind;
  toast.visible = true;
  if (_timer) clearTimeout(_timer);
  _timer = setTimeout(() => { toast.visible = false; }, durationMs);
}

export function hideToast() {
  toast.visible = false;
  if (_timer) clearTimeout(_timer);
}
